import { css, cx, etiColors, mediaQueries } from '@eti/styles';
import { useTranslation } from '@eti/providers';
import { price as priceUtils } from '@eti/utils';
import { Radio, RadioGroup } from '@etg/wings';
import { getOptions } from '../utils/seatingPreference';
import { SEATING_PREFERENCE_OPTIONS, SEATING_PREFERENCE_VALUES } from '../utils/constants';
import { screenReaderOnly } from '../../common/utils/styles';
import SegmentPanel from './segment-panel/SegmentPanel';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const radioStyles = css`
  align-items: center;
  border: 1px solid ${etiColors.grayScale[6]};
  border-radius: 0.188rem;
  display: flex;
  height: 2.625rem;
  margin-bottom: 0.5rem;
  padding: 0.75rem;
  width: 100%;

  &:not(:last-child) {
    &.radio_option {
      margin-bottom: 0.5rem;
    }
  }

  .etiCustomRadio {
    position: relative;
  }

  @media ${mediaQueries.large.up} {
    padding-left: 1rem;
  }

  html[dir='rtl'] & {
    padding-left: 1rem;
  }
`;
const priceStyles = css`
  flex-grow: 1;
  font-size: 0.875rem;
  font-weight: 700;
  margin: 0 0 0 auto;
  text-align: right;
  width: 30%;

  html[dir='rtl'] & {
    margin: 0.25rem auto 0 0;
    text-align: left;
  }
`;
const labelStyles = css`
  flex-grow: 1;
  font-size: 0.875rem;
  padding: 0 0.625rem;
`;
const SeatingPreference = _ref => {
  var _selectedSeats$0$seat, _selectedSeats$;
  let {
    activeSegment,
    __typename: type = SEATING_PREFERENCE_OPTIONS.SELL_SEATING_BESIDE,
    price: {
      markup: markupData,
      price: {
        value: priceValue
      } = {
        value: 0
      }
    },
    onChange,
    selectedSeats
  } = _ref;
  const {
    t
  } = useTranslation();
  const options = getOptions(type);
  const selectedPreference = (_selectedSeats$0$seat = selectedSeats === null || selectedSeats === void 0 || (_selectedSeats$ = selectedSeats[0]) === null || _selectedSeats$ === void 0 ? void 0 : _selectedSeats$.seatPreference) !== null && _selectedSeats$0$seat !== void 0 ? _selectedSeats$0$seat : null;
  const priceMarkup = markupData !== null && typeof markupData === 'object' ? markupData.value : markupData;
  const seatPreferences = value => value !== SEATING_PREFERENCE_VALUES.NO_OPTION ? {
    price: priceValue,
    markup: priceMarkup,
    seatPreference: value
  } : {
    price: 0,
    markup: priceMarkup,
    seatPreference: value
  };
  const onChangeHandler = (_event, value) => {
    const segment = {
      ...seatPreferences(value)
    };
    onChange(segment)();
  };
  const getPrice = value => value && value !== SEATING_PREFERENCE_VALUES.NO_OPTION ? priceValue : 0;
  const seatingPreferenceType = type === SEATING_PREFERENCE_OPTIONS.SELL_SEATING_BESIDE ? 'SeatingBeside' : 'SeatingLight';
  const title = t(`Product.SeatMap.Segment.Unavailable.${seatingPreferenceType}.Title`);
  const content = t(`Product.SeatMap.Segment.Unavailable.${seatingPreferenceType}.Content`);
  const getIcons = () => {
    const defaultIcons = [[{
      id: 'c_flat-seat-selected-blue',
      size: '32px'
    }], [{
      id: 'c_flat-seat-selected-blue',
      size: '32px'
    }]];
    const aisleAndWindowIcons = [{
      id: 'c_flat-seat-preference',
      height: '18px',
      width: '12px',
      top: '4px'
    }];
    if (type === SEATING_PREFERENCE_OPTIONS.SELL_SEATING_BESIDE) {
      return defaultIcons;
    }
    return [...defaultIcons, aisleAndWindowIcons];
  };
  const radioGroupName = window.location.pathname.includes('seating') ? `seatMap.${activeSegment}.traveler0.seatPreference` : `${activeSegment}.traveler0.seatPreference`;
  return /*#__PURE__*/_jsxs(RadioGroup, {
    "data-testid": `seatMap-seatingCombo-${type}`,
    name: radioGroupName,
    onChange: event => onChangeHandler(event, event === null || event === void 0 ? void 0 : event.target.value),
    selectedValue: selectedPreference,
    children: [/*#__PURE__*/_jsxs(RadioGroup.Legend, {
      className: screenReaderOnly,
      children: [title, content]
    }), /*#__PURE__*/_jsx(SegmentPanel, {
      content: content,
      icons: getIcons(),
      title: title,
      children: options.map(_ref2 => {
        let {
          label,
          value,
          id
        } = _ref2;
        return /*#__PURE__*/_jsxs(Radio.Label, {
          className: cx('radio_option', radioStyles),
          htmlFor: id,
          children: [/*#__PURE__*/_jsx(Radio, {
            "data-testid": `seating-combo-${id}`,
            id: id,
            value: value
          }), /*#__PURE__*/_jsx("span", {
            className: labelStyles,
            children: t(label)
          }), /*#__PURE__*/_jsx("span", {
            className: priceStyles,
            children: priceUtils.formatPrice(getPrice(value))
          })]
        }, id);
      })
    })]
  });
};
export default SeatingPreference;
//# sourceMappingURL=SeatingPreference.js.map